module.exports = __webpack_public_path__ + "img/macos.2ba362ca.svg";